import React, { useRef, useEffect } from 'react'
import { ReactComponent as NotificationIcon } from "../../../design-system/design_system/assets/icons/system/notification.svg";
import { ReactComponent as MyAccountIcon } from "../../../design-system/design_system/assets/icons/system/account.svg";
import { connect } from "react-redux";
import { menuOverlay } from "../../actions/HeaderActions";
import { bindActionCreators } from 'redux';
import BookSubMenu from "./BookSubMenu";
import SecondBookSubMenuTheme from "./SecondBookSubMenuTheme";
import DreamSubMenu from "./DreamSubMenu";
import {teamSiteUrlFormate}  from "../../../utils/dateFormate";
const Desktopmenu = (props) => {
    //console.log(props);
    const {showDreamSubMenu, BookMenu, DreamMenuFunc, windowClickMenuCloseFunc,
        notificationData, handleNotificationFunc, handleMyAccountFunc, 
        showBookSubMenu, displayNotificationFlag, displayMyAccountFlag,
        $showSubMenu, $subMenuArr, $bookSubmenuSecondViewArr, deviceWidth,
        $showDreamSubMenu, $dreamSubMenuArr,$tradingPowerBlnc } = props;
    const subMenuWrapper = useRef();
    const dreamSubMenuWrapper = useRef();
    const notificationWrapper = useRef();
    const myAccountnWrapper = useRef();
    window.onclick = function (event) {
        //const headerContainer = (subMenuWrapper.current);
        if ((subMenuWrapper.current && !subMenuWrapper.current.contains(event.target)) &&
            (dreamSubMenuWrapper.current && !dreamSubMenuWrapper.current.contains(event.target))
            &&
            notificationWrapper.current && !notificationWrapper.current.contains(event.target)
            && myAccountnWrapper.current && !myAccountnWrapper.current.contains(event.target)
        ) {
            windowClickMenuCloseFunc();
            //BookMenu(event);
            //DreamSubMenuFunc(event);
        }

        else return false;
    }
    useEffect(() => {
        ///let navArr = []
        // RenderMenu();
    }, [])
    

    return (
        <div className="nav-menu float-right d-none d-lg-block d-lg-flex" data-testid="nav-menu">

            {
                props.MenuArr.map((data, index) => {
                    
                    if (Object.keys(data)[0] === "LinksWithTravel") {
                        return (
                        <>
                        <a href="#!" 
                        data-testid={data.LinksWithTravel.DisplayText} 
                        key={index} ref={subMenuWrapper} 
                        className={showBookSubMenu ? "nav-more active" : "nav-more"} 
                        onClick={(event) => BookMenu(event)}
                        aria-label = {data.LinksWithTravel.DisplayText}
                        >{data.LinksWithTravel.DisplayText}</a>
                        {($subMenuArr !== null) &&
                        <BookSubMenu
                            showSubMenu={$showSubMenu}
                            subMenuArr={$subMenuArr}
                            
                        />
                    }
                        </>
                        );
                    }
                    else if (Object.keys(data)[0] === "LinksWithoutTravel") {
                        return(
                        <>
                        <a href="#!" 
                        data-testid={data.LinksWithoutTravel.DisplayText} 
                        key={index} ref={subMenuWrapper} 
                        className={showBookSubMenu ? "nav-more active" : "nav-more"} 
                        onClick={(event) => BookMenu(event)}
                        aria-label = {data.LinksWithoutTravel.DisplayText}
                        >{data.LinksWithoutTravel.DisplayText}</a>
                            {($bookSubmenuSecondViewArr !== null) &&
                            <SecondBookSubMenuTheme
                                showSubMenu={$showSubMenu}
                                subMenuArr={$bookSubmenuSecondViewArr}
                            />
                        }
                        </>
                        )
                    }
                    else if (Object.keys(data)[0] === "LinksWithActivities") {
                        return(
                            <>
                              <a href="#!" 
                              data-testid={data.LinksWithActivities.DisplayText} 
                              key={index} ref={dreamSubMenuWrapper} 
                              className={showDreamSubMenu ? "nav-more active" : "nav-more"} 
                              onClick={(event) => DreamMenuFunc(event)}
                              aria-label = {data.LinksWithActivities.DisplayText}
                              >{data.LinksWithActivities.DisplayText}</a>
                              {($dreamSubMenuArr !== null) &&
                            <DreamSubMenu
                                showDreamSubMenu={$showDreamSubMenu}
                                dreamSubMenuArr={$dreamSubMenuArr} 
                            />
                            }
                           
                            </>
                           
                        ) 
                    }
                    else if (Object.keys(data)[0] === "Links") {

                        return <a href={teamSiteUrlFormate(data.Links.URL)} 
                        data-testid={data.Links.DisplayText} 
                        key={index}  
                        aria-label = {data.Links.DisplayText}
                        >{data.Links.DisplayText}</a>

                        //console.log(data, index)
                    }
                    else return null;
                    // setMainna(navArr);
                })
            }

            <div className="divider"></div>

            <a href="#!"
                data-testid = "notification"
                className={`${displayNotificationFlag ? "active nav-icon" : "nav-icon" }`}
                ref={notificationWrapper}
                onClick={handleNotificationFunc}
                aria-label="notification"
            >
                <NotificationIcon className="svg-fill-black" />
                {notificationData.Alert !== undefined &&
                 <span className="absolute-position rounded-circle bg-watermelon alert-count">
                 {notificationData.Alert.length}
                 </span>
                }
               
            </a>

            <a href="#!" 
                data-testid = "my-account"
                className={`${displayMyAccountFlag ? "active nav-icon" : "nav-icon"}`}
                ref={myAccountnWrapper}
                onClick={handleMyAccountFunc}
                aria-label="my-account"
                >
                <MyAccountIcon className="svg-fill-black" />
            </a>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        showOverlay: state.CommonReducer.showOverlay,
        notificationData: state.CommonReducer.notification
    }

}
const mapDispatchToProps = dispatch => bindActionCreators({
    menuOverlayfunc: menuOverlay
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Desktopmenu);



